module.exports = __webpack_public_path__ + "img/logo-footer.a5042cc9.png";